<template>
  <v-container fluid>
      <v-card>
          <v-toolbar dense color="#96298A" dark>
              <v-toolbar-title>Reporte de Importaciones</v-toolbar-title>
              <v-toolbar-items>
                  <v-divider class="mx-4" vertical />
                  <v-text-field filled v-model="desde" type="date" clearable label="Desde"></v-text-field><v-divider class="mx-4" vertical />
                  <v-text-field filled v-model="hasta" type="date" clearable label="Hasta"></v-text-field><v-divider class="mx-4" vertical />
                 <v-btn dark dense @click="getDatosReporte()" outlined exact > Generar <v-icon>mdi-file</v-icon></v-btn>
              </v-toolbar-items>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                  <v-divider class="mx-4" vertical></v-divider>
                  <v-text-field
                    v-model="searcher"
                    append-icon="mdi-file-search"
                    label="Buscar"
                    single-line
                    hide-details
                    clearable
                    max-width="200px"
                    ></v-text-field>
                  <v-divider vertical></v-divider>
                    <v-tooltip bottom color="#96298A">
                        <template v-slot:activator="{ on, attrs }">
                        <v-btn icon large v-bind="attrs" v-on="on" @click="exportToExcel()">
                            <v-icon>mdi-microsoft-excel</v-icon>
                        </v-btn>
                        </template>
                        <span>Descargar Excel</span>
                    </v-tooltip>
              </v-toolbar-items>
          </v-toolbar>
          <v-card-text>
              <v-data-table
              :items="datosReporte"
              :headers="headersReporte"
              :search="searcher"
              >
              <template v-slot:item.direccion_c="{ item }">
                  {{item.direccion1_c + ' ' + item.direccion2_c + ' ' + (item.direccion3_c != null ? item.direccion3_c : '')}}
              </template>
              <template v-slot:item.direccion_e="{ item }">
                  {{item.direccion1_e + ' ' + item.direccion2_e + ' ' + (item.direccion3_e != null ? item.direccion3_e : '')}}
              </template>
              <template v-slot:item.cargosadicionales="{ item }">
                  <span v-for="(ca,index) in item.cargosadicionales" :key="index">{{ca.cargo.cargo + (ca.observacion != null ? '(' + ca.observacion + ')': '') + '=$' + ca.valor + ', '}} </span>
              </template>
              <template v-slot:item.totalcargos="{ item }">
                  ${{item.cargosadicionales.reduce((sumv, itemv) => sumv + parseFloat(itemv.valor),0)}}
              </template>
              <template v-slot:item.reclamos="{ item }">
                  <span v-for="(re,index) in item.reclamoslst" :key="index">{{(re.causal != null ? re.causal.causal : '') + (re.estado != null ? '(' + re.estado.estado + ')' : '') + ', '}}</span>
              </template>
              <template v-slot:item.rpppeso="{ item }">
                  {{item.paquetes.reduce((sumv, itemv) => sumv + parseFloat(itemv.pesototal_r != null ? itemv.pesototal_r : 0),0)}}
              </template>
              <template v-slot:item.rppmedidas="{ item }">
                  <span v-for="(rpm,index) in item.paquetes" :key="index">{{rpm.largo_r != null ? (rpm.largo_r + 'X' + rpm.ancho_r + 'X' + rpm.alto_r + ', ') : ''}}</span>
              </template>
              <template v-slot:item.medidas="{ item }">
                  <span v-for="(m,index) in item.paquetes" :key="index">{{m.largo != null ? (m.largo + 'X' + m.ancho + 'X' + m.alto + ', ') : ''}}</span>
              </template>
              <template v-slot:item.created_at="{ item }">
                  {{formatDate(item.created_at)}}
              </template>
              <template v-slot:item.fecha_estatus="{ item }">
                {{
                  item.ultimoestatus != null
                    ? formatDate(
                        item.ultimoestatus.fecha + 'T00:00:00Z'
                      )
                    : null
                }}
              </template>
              <template v-slot:item.ultimo_estatus="{ item }">
                {{
                  item.ultimoestatus != null
                    ? item.ultimoestatus.estatus.descripcion
                    : null
                }}
              </template>
              <template v-slot:item.comentario_estatus="{ item }">
                {{
                  item.ultimoestatus != null
                    ? item.ultimoestatus.comentarios
                    : null
                }}
              </template>
              </v-data-table>
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script>
import apicon from '../plugins/apicon'
import utils from '../utils/utils'
const XLSX = require('xlsx')
export default {
created: function(){},
data(){
    return{
        desde: null,
        hasta: null,
        isCliente: false,
        searcher: '',
        datosReporte: [],
        headersReporte:[
            { text: "Fecha Ingreso AWB", value: "created_at", sortable: false },
            { text: "Fecha Pickup", value: "fecha_pickup", sortable: false },
            { text: "Fecha Arribo", value: "fecha_arribo", sortable: false },
            { text: "Fecha Entrega", value: "podfecha", sortable: false },
            { text: "Persona que Recibio", value: "podnombre", sortable: false },
            { text: "PU Reference Schedule", value: "pu_reference_shedule", sortable: false },
            { text: "AWB INEX", value: "guia_interna", sortable: false },
            { text: "Operador", value: "proveedor", sortable: false },
            { text: "AWB Operador", value: "guia_proveedor", sortable: false },
            { text: "Via", value: "via", sortable: false },
            { text: "Facturar a", value: "clientefacturar.empresa", sortable: false },
            { text: "Empresa (Receiver)", value: "empresa_c", sortable: false },
            { text: "Contacto (Receiver)", value: "contacto_c", sortable: false },
            { text: "Vat Num (Receiver)", value: "nit_c", sortable: false },
            { text: "Email (Receiver)", value: "correo_c", sortable: false },
            { text: "Dirección (Receiver)", value: "direccion_c", sortable: false },
            { text: "Ciudad (Receiver)", value: "ciudad_c", sortable: false },
            { text: "ZIP (Receiver)", value: "zip_c", sortable: false },
            { text: "Teléfono (Receiver)", value: "telefono_c", sortable: false },
            { text: "País (Receiver)", value: "pais_c", sortable: false },
            { text: "Empresa (Sender)", value: "empresa_e", sortable: false },
            { text: "Contacto (Sender)", value: "contacto_e", sortable: false },
            { text: "Vat Num (Sender)", value: "nit_e", sortable: false },
            { text: "Email (Sender)", value: "correo_e", sortable: false },
            { text: "Dirección (Sender)", value: "direccion_e", sortable: false },
            { text: "Ciudad (Sender)", value: "ciudad_e", sortable: false },
            { text: "ZIP (Sender)", value: "zip_e", sortable: false },
            { text: "Teléfono (Sender)", value: "telefono_e", sortable: false },
            { text: "País (Sender)", value: "pais_e", sortable: false },
            { text: "Descripción", value: "descripcion", sortable: false },
            { text: "Piezas", value: "piezas", sortable: false },
            { text: "Peso (kgs)", value: "peso", sortable: false },
            { text: "Medidas (cm)", value: "medidas", sortable: false },
            { text: "Valor Declarado", value: "valor", sortable: false },
            { text: "Moneda", value: "moneda", sortable: false },
            { text: "Incoterm", value: "termino", sortable: false },
            { text: "Referencia del Cliente", value: "referencia_cliente", sortable: false },
            { text: "Seguro", value: "seguro", sortable: false },
            { text: "Valor Contenido", value: "seg_valor_contenido", sortable: false },
            { text: "Flete Int", value: "seg_flete_int", sortable: false },
            { text: "Flete Nac", value: "seg_flete_nac", sortable: false },
            { text: "Valor Total Seguro", value: "seg_valor_total", sortable: false },
            { text: "No Aplicación", value: "seg_no_aplicacion", sortable: false },
            { text: "Cargos Adicionales", value: "cargosadicionales", sortable: false },
            { text: "Total Cargos", value: "totalcargos", sortable: false },
            { text: "Régimen", value: "regimen", sortable: false },
            { text: "Estatus", value: "ultimo_estatus", sortable: false },
            { text: "Fecha Estatus", value: "fecha_estatus", sortable: false },
            {
              text: "Comentario Estatus",
              value: "comentario_estatus",
              sortable: false,
            },
            { text: "Arribo en", value: "arribo_en", sortable: false },
            { text: "Tipo de Persona", value: "tipo_persona", sortable: false },
            { text: "Origen", value: "origen_per", sortable: false },
            { text: "Cliente Operador Postal", value: "cliente_operador_postal", sortable: false },
            { text: "Reclamos", value: "reclamos", sortable: false },
            { text: "RPP Peso", value: "rpppeso", sortable: false },
            { text: "RPP Medidas", value: "rppmedidas", sortable: false },
            { text: "Valor Declarado Aduana", value: "valor_declarado_aduana", sortable: false },
            { text: "Fecha de Envío de Datos al Agente", value: "fecha_envio_datos_agente", sortable: false },
            { text: "Fecha de Declaración", value: "fecha_declaracion", sortable: false },
            { text: "Fecha de Pago de Impuesto", value: "fecha_pago_imp", sortable: false },
            { text: "Fecha de Liberación Aduana", value: "fecha_liberacion_aduana", sortable: false },
            { text: "Observaciones", value: "observaciones", sortable: false },
        ],
    }
},
methods:{
    getDatosReporte: function(){
        apicon.saveDataApi(apicon.getApiBaseUrl() + 'reporteimportaciones',{
            desde: this.desde,
            hasta: this.hasta
            }).then((result) => {
                this.datosReporte = result
            });
    },
    formatDate: function(date){
        return utils.formatDate(date)
    },
    exportToExcel: function(){
        //Map Data to new Json
        let newJson = this.datosReporte.map(rec => {
            return{
                'Fecha Ingreso AWB' :  new Date (new Date(rec.created_at).toISOString().substring(0,10) + 'T00:00:00'),
                'Fecha Pickup': rec.fecha_pickup != null ? new Date(rec.fecha_pickup + 'T00:00:00') : '',
                "Fecha Arribo": rec.fecha_arribo != null ? new Date(rec.fecha_arribo + 'T00:00:00') : '',
                "Fecha Entrega": rec.podfecha != null ? new Date(rec.podfecha + 'T00:00:00') : '',
                "Persona que Recibio": rec.podnombre,
                "PU Reference Schedule": rec.pu_reference_shedule,
                "AWB INEX": rec.guia_interna,
                "Operador": rec.proveedor,
                "AWB Operador": rec.guia_proveedor,
                "Via": rec.via,
                "Facturar a": rec.clientefacturar != undefined ? rec.clientefacturar.empresa: '',
                "Empresa (Receiver)": rec.empresa_c,
                "Contacto (Receiver)": rec.contacto_c,
                "Vat Num (Receiver)": rec.nit_c,
                "Email (Receiver)": rec.correo_c,
                "Dirección (Receiver)": rec.direccion1_c + ' ' + rec.direccion2_c + ' ' + (rec.direccion3_c != null ? rec.direccion3_c : ''),
                "Ciudad (Receiver)": rec.ciudad_c,
                "ZIP (Receiver)": rec.zip_c,
                "Teléfono (Receiver)": rec.telefono_c,
                "País (Receiver)": rec.pais_c,
                "Empresa (Sender)": rec.empresa_e,
                "Contacto (Sender)": rec.contacto_e,
                "Vat Num (Sender)": rec.nit_e,
                "Email (Sender)": rec.correo_e,
                "Dirección (Sender)": rec.direccion1_e + ' ' + rec.direccion2_e + ' ' + (rec.direccion3_e != null ? rec.direccion3_e : ''),
                "Ciudad (Sender)": rec.ciudad_e,
                "ZIP (Sender)": rec.zip_e,
                "Teléfono (Sender)": rec.telefono_e,
                "País (Sender)": rec.pais_e,
                "Descripción": rec.descripcion,
                "Piezas": rec.piezas,
                "Peso (kgs)": rec.peso,
                "Medidas (cm)": rec.paquetes.reduce((pv,cv) => pv + (cv.largo != null ? (cv.largo + 'X' + cv.ancho + 'X' + cv.alto + ',') : ''),""),
                "Valor Declarado": rec.valor,
                "Moneda": rec.moneda,
                "Incoterm": rec.termino,
                "Referencia del Cliente": rec.referencia_cliente,
                "Seguro": rec.seguro,
                "Valor Contenido": rec.seg_valor_contenido,
                "Flete Int": rec.seg_flete_int,
                "Flete Nac": rec.seg_flete_nac,
                "Valor Total Seguro": rec.seg_valor_total,
                "No Aplicación": rec.seg_no_aplicacion,
                'Cargos Adicionales': rec.cargosadicionales.reduce((pv, cv) => pv + cv.cargo.cargo + (cv.observacion != null ? '(' + cv.observacion + ')' : '') + '=$' + cv.valor + ', ' ,""),
                'Total Cargos': rec.cargosadicionales.reduce((sumv, itemv) => sumv + parseFloat(itemv.valor),0),
                "Régimen": rec.regimen,
                "Estatus": rec.ultimoestatus != null
                            ? rec.ultimoestatus.estatus.descripcion
                            : null,
                "Fecha Estatus":
                          rec.ultimoestatus != null
                            ?
                            this.formatDate(rec.ultimoestatus.created_at)
                            : null
                        ,
                "Comentario Estatus":  rec.ultimoestatus != null
                            ? rec.ultimoestatus.comentarios
                            : null,
                "Arribo en": rec.arribo_en,
                "Tipo de Persona": rec.tipo_persona,
                "Origen": rec.origen_per,
                "Cliente Operador Postal": rec.cliente_operador_postal,
                "Reclamos": rec.reclamoslst.reduce((pv,cv) => pv + (cv.causal != undefined ? cv.causal.causal : '') + (cv.estado != undefined ? '(' + cv.estado.estado + '),' : ''),""),
                "RPP Peso": rec.paquetes.reduce((sumv,itemv) => sumv + parseFloat(itemv.pesototal_r != null ? itemv.pesototal_r : 0),0),
                "RPP Medidas": rec.paquetes.reduce((pv,cv) => pv + (cv.largo_r != null ? (cv.largo_r + 'X' + cv.ancho_r + 'X' + cv.alto_r + ',') : ''),""),
                "Valor Declarado Aduana": rec.valor_declarado_aduana,
                "Fecha de Envío de Datos al Agente": rec.fecha_envio_datos_agente != null ? new Date(rec.fecha_envio_datos_agente + 'T00:00:00') : '',
                "Fecha de Declaración": rec.fecha_declaracion != null ? new Date(rec.fecha_declaracion + 'T00:00:00') : '',
                "Fecha de Pago de Impuesto": rec.fecha_pago_imp != null ? new Date(rec.fecha_pago_imp + 'T00:00:00') : '',
                "Fecha de Liberación Aduana": rec.fecha_liberacion_aduana != null ? new Date(rec.fecha_liberacion_aduana + 'T00:00:00') : '',
                "Observaciones": rec.observaciones,
            }
        });
        let data = XLSX.utils.json_to_sheet(newJson)
        const workbook = XLSX.utils.book_new()
        const filename = 'Reporte de Importaciones';
        //Fit columns
        const wscols = utils.getAutoFitColumns(newJson);
        data["!cols"] = wscols;

        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
    },
},
mounted: function(){
    apicon.setAuthHeaders();
    this.isCliente = localStorage.getItem("cliente");
    //this.getDatosReporte();
}
}
</script>
